export function validarEmail(email) {
  // Verifica se o campo de e-mail foi preenchido
  if (!email) {
    return false;
  }

  // Verifica se o e-mail possui o formato correto
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function validarCPFCNPJ(documento) {
  // Remove caracteres especiais do documento
  documento = documento.replace(/[^\d]+/g, '');

  // Armazena a quantidade de dígitos do documento em uma variável
  const numDigitos = documento.length;

  // Verifica se o documento é um CPF ou CNPJ
  if (numDigitos === 11) {
    // É um CPF, chama a função de validação correspondente
    return validarCPF(documento);
  } else if (numDigitos === 14) {
    // É um CNPJ, chama a função de validação correspondente
    return validarCNPJ(documento);
  } else {
    // Não é um CPF nem um CNPJ válido
    return false;
  }
}

function validarCPF(cpf) {
  // Verifica se o CPF tem 11 dígitos
  if (cpf.length !== 11) {
    return false;
  }

  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{10}$/.test(cpf)) {
    return false;
  }

  // Verifica o primeiro dígito verificador
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let resto = 11 - (soma % 11);
  let digitoVerificador1 = resto === 10 || resto === 11 ? 0 : resto;

  if (digitoVerificador1 !== parseInt(cpf.charAt(9))) {
    return false;
  }

  // Verifica o segundo dígito verificador
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i)) * (11 - i);
  }
  resto = 11 - (soma % 11);
  let digitoVerificador2 = resto === 10 || resto === 11 ? 0 : resto;

  if (digitoVerificador2 !== parseInt(cpf.charAt(10))) {
    return false;
  }

  // CPF válido
  return true;
}

function validarCNPJ(cnpj) {
  // Verifica se o CNPJ tem 14 dígitos
  if (cnpj.length !== 14) {
    return false;
  }

  // Verifica primeiro dígito verificador
  let soma = 0;
  let peso = 2;
  for (let i = 11; i >= 0; i--) {
    soma = soma + parseInt(cnpj.charAt(i)) * peso;
    peso = peso < 9 ? peso + 1 : 2;
  }
  let resto = soma % 11;
  if (resto < 2) {
    resto = 0;
  } else {
    resto = 11 - resto;
  }
  if (resto != parseInt(cnpj.charAt(12))) {
    return false;
  }

  // Verifica segundo dígito verificador
  soma = 0;
  peso = 2;
  for (let i = 12; i >= 0; i--) {
    soma = soma + parseInt(cnpj.charAt(i)) * peso;
    peso = peso < 9 ? peso + 1 : 2;
  }
  resto = soma % 11;
  if (resto < 2) {
    resto = 0;
  } else {
    resto = 11 - resto;
  }
  if (resto != parseInt(cnpj.charAt(13))) {
    return false;
  }

  // Se passou por todas as validações, retorna true
  return true;
}

export function validarTelefone(telefone) {
  // Verifica se o campo de e-mail foi preenchido
  if (!telefone) {
    return false;
  }

  const telefoneLength = telefone.length;

  if (telefoneLength < 14) {
    return false;
  }

  return true;
}

export function validarCep(cep) {
  if (!(cep.length > 9)) {
    return /^[0-9]{5}-[0-9]{3}$/.test(cep);
  }
}
